import {
	Box,
	Button,
	Checkbox, Container, Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	InputAdornment, makeStyles,
	Step,
	StepLabel, Stepper,
	SvgIcon, Table,
	TableBody,
	TableCell,
	TableContainer, TableHead,
	TablePagination,
	TableRow, TextField,
	Tooltip, Chip, LinearProgress
} from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { Search as SearchIcon } from 'react-feather';
import DoneIcon from "@material-ui/icons/Done";
import DayjsUtils from "@date-io/dayjs";
import { MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import { green } from "@material-ui/core/colors";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSnackbar } from 'notistack';
import Fuse from 'fuse.js';
import { useActions, useValues } from 'kea';
import { mdiHours24 } from '@mdi/js';
import Icon from '@mdi/react';

import geofencelogic from "src/store/geofence";
import vehiclelogic from "src/store/vehicle";

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		height: '600px'
	},
}));

const columns = [
	{
		field: 'info',
		headerName: 'Vehicle Details',
		align: 'left',
		width: 400,
	},
	{
		field: 'actions',
		// headerName: 'Select',
		align: 'right',
		width: 100,
	}
];

const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

function getSteps() {
	return ['Select Vehicles to be included', 'Assign Timeslots to the Vehicles'];
}

const initialGeofenceAssignment = {
	vehicles: [],
	timeSlots: []
}

const AddVehicleDialog = ({ selectedGeofence, geofenceIndex }) => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const [open, setOpen] = React.useState(false);
	const [activeStep, setActiveStep] = React.useState(0);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const steps = getSteps();

	const { geofences } = useValues(geofencelogic);
	const { update } = useActions(geofencelogic);

	const { vehicles } = useValues(vehiclelogic);

	const [GeofenceAssignment, setGeofenceAssignment] = React.useState(initialGeofenceAssignment);

	const [rows, setRows] = React.useState([]);
	React.useEffect(() => {
		const selectedGeofenceIds = geofences[geofenceIndex].vehicles.map((iRow) => {
			return iRow.vehicle._id;
		});

		let unfiltered_rows = vehicles.filter((aRow) => {
			return !selectedGeofenceIds.includes(aRow._id);
		});
		setRows(unfiltered_rows);
	}, [geofences, selectedGeofence])// eslint-disable-line

	if (!rows) {
		return (
			<>
				<LinearProgress />
			</>
		)
	}

	const fuse = new Fuse(rows, {
		keys: ['tags', 'type', 'name', 'registration_number', 'registration_state', 'company', 'model', 'year', 'color']
	});
	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
		handleReset();
	}

	const handleNext = () => {
		if (activeStep === 0) {
			if (GeofenceAssignment.vehicles.length === 0) {
				enqueueSnackbar('Please select vehicles first.', { variant: 'error' });
				return;
			}
			setActiveStep((prevActiveStep) => prevActiveStep + 1);
			return;
		} else if (activeStep === 1) {
			if (GeofenceAssignment.timeSlots.length === 0) {
				enqueueSnackbar('Please add timeslot(s) first.', { variant: 'error' });
				return;
			}
			handle_add();
			handleReset();
			setOpen(false);
			return;
		}
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setGeofenceAssignment({
			vehicles: [],
			timeSlots: []
		});
		setActiveStep(0);
	};

	const handleChangeVehicle = (value) => {
		let updated = { ...GeofenceAssignment };
		if (updated.vehicles.includes(value)) {
			updated.vehicles.splice(updated.vehicles.indexOf(value), 1);
		} else {
			updated.vehicles.push(value);
		}
		setGeofenceAssignment(updated);
	}


	const handleAddRow = () => {
		let new_rows = { ...GeofenceAssignment };
		let startD = new Date();
		startD.setDate(0);
		startD.setMonth(0);
		startD.setFullYear(0);
		startD.setHours(0);
		startD.setMinutes(0);
		let endD = new Date();
		endD.setDate(0);
		endD.setMonth(0);
		endD.setFullYear(0);
		endD.setHours(23);
		endD.setMinutes(59);
		new_rows.timeSlots.push({
			name: "24/7",
			instant: false,
			start: startD,
			end: endD,
			days: [
				"monday",
				"tuesday",
				"wednesday",
				"thursday",
				"friday",
				"saturday",
				"sunday"
			],
			notification_on_entry: true,
			notification_on_exit: true
		});
		setGeofenceAssignment(new_rows);
	};

	const handleDate = (index, name, value) => {
		let new_rows = { ...GeofenceAssignment };
		new_rows.timeSlots[index][name] = value.toISOString();
		setGeofenceAssignment(new_rows);
	};

	const handleDays = (index, name, value) => {
		let new_rows = { ...GeofenceAssignment };
		if (value) {
			new_rows.timeSlots[index]["days"].push(name);
		} else if (!value && new_rows.timeSlots[index]["days"].indexOf(name) !== -1) {
			new_rows.timeSlots[index]["days"].splice(new_rows.timeSlots[index]["days"].indexOf(name), 1);
		}
		setGeofenceAssignment(new_rows);
	};

	const handleRemove = (index) => {
		let new_rows = { ...GeofenceAssignment };
		new_rows.timeSlots.splice(index, 1);
		setGeofenceAssignment(new_rows);
	};


	const handleChangeTimeslot = (index, name, value) => {
		let new_rows = { ...GeofenceAssignment };
		new_rows.timeSlots[index][name] = value;
		setGeofenceAssignment(new_rows);
	};

	const handle_add = () => {
		let updated_geofence = selectedGeofence;
		GeofenceAssignment.vehicles.forEach((vehicle) => {
			updated_geofence.vehicles.push({
				schedule: GeofenceAssignment.timeSlots,
				vehicle: vehicles.find((aRow) => {
					return vehicle === aRow._id;
				}),
				enabled: true
			});
		});

		update(updated_geofence);
	}

	const handle_search = (e) => {
		if (e.target.value) {
			let found = fuse.search(e.target.value);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});

			setRows(found);
		} else {
			const selectedGeofenceIds = geofences[geofenceIndex].vehicles.map((iRow) => {
				return iRow.vehicle._id;
			});

			let unfiltered_rows = vehicles.filter((aRow) => {
				return !selectedGeofenceIds.includes(aRow._id);
			});
			setRows(unfiltered_rows);
		}
	};

	return (
		<>
			<Tooltip title="Add Vehicles to this geofence">
				<div style={{ paddingLeft: '22px', paddingTop: '5px' }}>
					<Button
						color="default"
						variant="contained"
						aria-label="update"
						size='large'
						onClick={handleClickOpen}
					>
						Add to Geofence
					</Button>
				</div>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">
					<Stepper activeStep={activeStep} alternativeLabel>
						{steps.map((label) => (
							<Step key={label}>
								<StepLabel>{label}</StepLabel>
							</Step>
						))}
					</Stepper>
					{activeStep === 0 ? <TextField
						size="small"
						fullWidth
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon
										fontSize="small"
										color="action"
									>
										<SearchIcon />
									</SvgIcon>
								</InputAdornment>
							)
						}}
						onChange={handle_search}
						placeholder="Search Vehicles"
						variant="outlined"
					/> : null}
				</DialogTitle>
				<DialogContent >
					{activeStep === 0
						?
						<div style={{ width: '1228px', background: 'white' }}>
							<TableContainer className={classes.container}>
								<Table stickyHeader aria-label="sticky table" size={'small'}>
									<TableHead>
										<TableRow>
											{columns.map((column) => (
												<TableCell
													key={column.field}
													align={column.align}
													style={{ minWidth: column.width }}
												>
													{column.headerName}
												</TableCell>
											))}
										</TableRow>
									</TableHead>
									<TableBody>
										{
											rows && rows.length > 0 ?
												rows
													.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
													.map((row) => {
														if (!row.enabled) return null;
														return (
															<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
																{columns.map((column) => {
																	if (column.field === 'actions') {
																		return (
																			<>
																				<TableCell key={column.field} align={column.align}>
																					<Checkbox
																						color="primary"
																						inputProps={{ 'aria-label': 'secondary checkbox' }}
																						checked={GeofenceAssignment.vehicles.includes(row._id)}
																						onChange={() => handleChangeVehicle(row._id)}
																					/>
																				</TableCell>
																			</>
																		)
																	}
																	if (column.field === 'info') {
																		return (
																			<>
																				<TableCell key={column.field} align={column.align}>
																					{withTooltip(`${row.type} - ${row.name} - ${row.registration_number}`, column.width)}
																				</TableCell>
																			</>
																		);
																	}
																	const value = row[column.field];
																	return (
																		<TableCell key={column.field} align={column.align}>
																			{column.format && typeof value === "number"
																				? column.format(value)
																				: value}
																		</TableCell>
																	);
																})}
															</TableRow>
														);
													})
												: <TableRow>
													<TableCell style={{ height: 61 * rowsPerPage }} colSpan={5} align={'center'}>
														No Data Added.
													</TableCell>
												</TableRow>
										}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						:
						<TableContainer>
							<Table className={classes.table} size="small" aria-label="a dense table">
								<TableHead>
									<TableRow>
										<TableCell
											align="left"
											style={{
												minWidth: 250,
											}}
										>
											Name
										</TableCell>
										<TableCell
											align="center"
											style={{
												minWidth: 100,
											}}
										>
											Instant
										</TableCell>
										<TableCell
											align="center"
											style={{
												minWidth: 150,
											}}
										>
											Enter/Exit
										</TableCell>
										<TableCell
											align="center"
											style={{
												minWidth: 110,
											}}
										>
											Start Time
										</TableCell>
										<TableCell
											align="center"
											style={{
												minWidth: 110,
											}}
										>
											End Time
										</TableCell>
										<TableCell
											align="center"
											style={{
												minWidth: 370,
											}}
										>
											Days
										</TableCell>
										<TableCell
											align="center"
											style={{
												minWidth: 90,
											}}
										>
											Actions
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{GeofenceAssignment.timeSlots.map((row, index) => (
										<TableRow key={`row-${index}`}>
											<TableCell component="th" scope="row">
												<TextField
													id={`name-${index}`}
													value={row.name}
													onChange={(e) => handleChangeTimeslot(index, "name", e.target.value)}
													error={row.name ? false : true}
													helperText={row.name ? false : 'Invalid'}
													inputProps={{
														maxLength: 24
													}}
												/>
											</TableCell>
											<TableCell align="right">
												<Checkbox checked={row.instant} onChange={(e) => handleChangeTimeslot(index, "instant", e.target.checked)} inputProps={{ "aria-label": "primary checkbox" }} color="primary" />
											</TableCell>
											<TableCell align="right">
												<div className={classes.chips}>
													<Chip
														style={{ border: "0px" }}
														label="Entry"
														clickable
														color="primary"
														variant={row.notification_on_entry ? "default" : "outlined"}
														onClick={(e) => handleChangeTimeslot(index, "notification_on_entry", !row.notification_on_entry)}
														deleteIcon={row.notification_on_entry ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														ml={1}
														label="Exit"
														clickable
														color="primary"
														variant={row.notification_on_exit ? "default" : "outlined"}
														onClick={(e) => handleChangeTimeslot(index, "notification_on_exit", !row.notification_on_exit)}
														deleteIcon={row.notification_on_exit ? <DoneIcon /> : null}
													/>
												</div>
											</TableCell>
											<TableCell align="right">
												<div style={{ maxWidth: 70 }}>
													<MuiPickersUtilsProvider utils={DayjsUtils}>
														<TimePicker autoOk ampm={false} variant="inline" value={row.start} onChange={(e) => handleDate(index, "start", e)} />
													</MuiPickersUtilsProvider>
												</div>
											</TableCell>
											<TableCell align="right">
												<div style={{ maxWidth: 70 }}>
													<MuiPickersUtilsProvider utils={DayjsUtils}>
														<TimePicker
															autoOk
															ampm={false}
															variant="inline"
															value={row.end}
															minDate={row.start}
															minDateMessage={"Date should not be before 'Start time'"}
															onChange={(e) => handleDate(index, "end", e)}
														/>
													</MuiPickersUtilsProvider>
												</div>
											</TableCell>
											<TableCell align="left">
												<div className={classes.chips}>
													<Chip
														style={{ border: "0px" }}
														label="Mon"
														clickable
														color="primary"
														variant={row.days.includes('monday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "monday", !row.days.includes('monday'))}
														deleteIcon={row.days.includes('monday') ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														label="Tue"
														clickable
														color="primary"
														variant={row.days.includes('tuesday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "tuesday", !row.days.includes('tuesday'))}
														deleteIcon={row.days.includes('tuesday') ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														label="Wed"
														clickable
														color="primary"
														variant={row.days.includes('wednesday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "wednesday", !row.days.includes('wednesday'))}
														onDelete={null}
														deleteIcon={row.days.includes('wednesday') ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														label="Thu"
														clickable
														color="primary"
														variant={row.days.includes('thursday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "thursday", !row.days.includes('thursday'))}
														deleteIcon={row.days.includes('thursday') ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														label="Fri"
														clickable
														color="primary"
														variant={row.days.includes('friday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "friday", !row.days.includes('friday'))}
														deleteIcon={row.days.includes('friday') ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														label="Sat"
														clickable
														color="primary"
														variant={row.days.includes('saturday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "saturday", !row.days.includes('saturday'))}
														deleteIcon={row.days.includes('saturday') ? <DoneIcon /> : null}
													/>
													<Chip
														style={{ border: "0px" }}
														label="Sun"
														clickable
														color="primary"
														variant={row.days.includes('sunday') ? "default" : "outlined"}
														onClick={(e) => handleDays(index, "sunday", !row.days.includes('sunday'))}
														deleteIcon={row.days.includes('sunday') ? <DoneIcon /> : null}
													/>
												</div>
											</TableCell>
											<TableCell align="right">
												<IconButton aria-label="delete" onClick={(e) => handleRemove(index)}>
													<DeleteIcon color="secondary" />
												</IconButton>
											</TableCell>
										</TableRow>
									))}
									<TableRow key={"Add Another"}>
										<TableCell align="center" colSpan={7}>
											<Tooltip title={'Add new timeslot'}>
												<IconButton aria-label="delete" onClick={handleAddRow}>
													<AddIcon style={{ color: green[500] }} />
												</IconButton>
											</Tooltip>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>}
				</DialogContent>
				<DialogActions>
					<Container maxWidth={false}>
						{activeStep === 0 ? <Box>
							<TablePagination
								rowsPerPageOptions={[rowsPerPage]}
								component="div"
								count={rows ? rows.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							<Divider />
						</Box> : null}
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<Tooltip title="Cancel">
									<Button
										color="primary"
										aria-label="update"
										size='large'
										onClick={handleClose}
									>
										Cancel
									</Button>
								</Tooltip>
								{activeStep === 1 ? <Tooltip title="Go Back">
									<Button
										color="primary"
										aria-label="update"
										onClick={handleBack}
									>
										Back
									</Button>
								</Tooltip> : null}
								<Tooltip title={activeStep === 0 ? 'Next Step' : 'Finish'}>
									<Button
										color="primary"
										aria-label="update"
										onClick={handleNext}
									>
										{activeStep === 0 ? 'Next' : 'Finish'}
									</Button>
								</Tooltip>
							</div>
						</Box>
					</Container>
				</DialogActions>
			</Dialog >
		</>
	);
};

export default AddVehicleDialog;
